import { EventKindDto, PublicEventStatusDto, type EventListItemDto } from "../../../autogen/bff-api";
import type { EventStatusInput } from "../../sourcing-events/EventStatusTag";

// The home shows V2 (public) events only, consistent with the v2 procurements list. Passing
// only V2 statuses makes the BFF skip the BSE repo entirely.
export const ACTIVE_V2_STATUSES: string[] = [
  PublicEventStatusDto.Published,
  PublicEventStatusDto.Evaluation,
  PublicEventStatusDto.AwardDecision,
  PublicEventStatusDto.Awarded,
];

// Draft plus the pre-publication states, so a pending or failed Doffin publish (action-required)
// still surfaces on the home.
export const DRAFT_V2_STATUSES: string[] = [
  PublicEventStatusDto.Draft,
  PublicEventStatusDto.PublicationPending,
  PublicEventStatusDto.PublicationFailed,
];

export const eventStatusTagInput = (event: EventListItemDto): EventStatusInput | null => {
  if (event.kind === EventKindDto.V1 && event.bseStatus) return { kind: "BSE", status: event.bseStatus };
  if (event.kind === EventKindDto.V2 && event.publicStatus) return { kind: "PUBLIC_V2", status: event.publicStatus };
  return null;
};

const SOON_DAYS = 3;
export const isDeadlineSoon = (deadline: string | null | undefined): boolean => {
  if (!deadline) return false;
  const ms = new Date(deadline).getTime() - Date.now();
  return ms >= 0 && ms <= SOON_DAYS * 86400000;
};

// Scope to "mine" by creator client-side. Don't push this onto the query via
// responsiblePersons/projectIds — the BFF treats those as BSE-only filters and skips the V2
// query entirely (the bug this replaced); V2 has no server-side creator filter.
export const eventsCreatedBy = (events: EventListItemDto[], personId: string): EventListItemDto[] =>
  events.filter((e) => e.createdBy?.id === personId);
